export const disponibile = "#15bd3b"
export const prenotato = "#f5002d"
export const vuoto = "transparent"
export const inPrenotazione = "#ffd800"
export const borderColor = "#3f888f"
export const disabili = "blue"